import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';

const { Search } = Input;

@inject('spaOfferStore')
@observer
class SearchMenuItemModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        };
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'Devarana Wellness',
                dataIndex: 'taskName',
                key: 'taskName',
                width: '40%'
            },
            {
                title: 'Category',
                dataIndex: 'parentName',
                key: 'parentName',
                width: '40%'
            },
            {
                title: 'Action',
                dataIndex: 'taskId',
                key: 'action',
                width: '10%',
                render: taskId => (
                    <span>
                        <Button onClick={() => this.selectSearchMenuItemClicked(taskId)} type='primary'>
                            Select
                        </Button>
                    </span>
                ),
            },
        ]
    }

    searchChanged = e => {
        this.props.spaOfferStore.setItemSearchValue(e.target.value);
        this.props.spaOfferStore.searchItem();
    }

    selectSearchMenuItemClicked = taskId => {
        this.props.spaOfferStore.searchItemSelected(taskId);
        this.props.spaOfferStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const {
            lastChildItemFilter,
            itemSearchValue
        } = this.props.spaOfferStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Devarana Wellness' value={itemSearchValue} onChange={this.searchChanged} />
                <Table columns={this.getColumns()} dataSource={lastChildItemFilter} />
            </React.Fragment>
        )
    }
}

export default SearchMenuItemModal